<div class="card">
    <div class="card_header">
        <div class="height_header row row_jc_space_btw">
            <div class="flex_title row">
                <p class="title fz_l fw_700">Заказы</p>
                <span class="separator"></span>
                <p class="subtitle fz_xs color_text_gray">Оплачено {{totalPaidOrders}}/{{totalOrders}}</p>
            </div>
            <app-pagination *ngIf="!dataMissing && orders.length > 0" [currentPage]="currentPage"
                [totalItems]="totalItems" [pageSize]="pageSize" (pageChange)="onPageChange($event)"></app-pagination>
        </div>
    </div>
    <div class="card_body">
        <app-skeleton *ngIf="isLoading" height="45" margin="15" [count]="6"></app-skeleton>
        <div class="no_data fz_l row row_ai_center row_jc_center color_red" *ngIf="dataMissing">{{typeof dataMissing === 'string' ? dataMissing : 'Данные отсутствуют'}}</div>
        <div class="row row_data row_jc_space_btw" *ngFor="let order of orders">
            <div class="flex_item">
                <p class="fz_s">{{order.code}}</p>
                <p class="fz_xs color_text_gray">{{order.firstname}} {{order.lastname}}</p>
            </div>
            <div class="flex_item fz_s text_uppercase"
                [ngClass]="{'color_red': order.status === 'Cancelled', 'color_green': order.status === 'Paid', 'color_dark_green': order.status === 'New', 'color_violet': order.status === 'Completed', 'color_violet': order.status === 'Processing'}">
                {{getOrderStatuses(order.status)}}</div>
        </div>
    </div>
</div>